import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { CartSliceState } from "../types";
import { addCheckoutExtraReducers } from "./checkout";
import { addDealerRemainsExtraReducers } from "./dealerRemains";
import { addFiltersExtraReducers } from "./filters";
import { addItemsExtraReducers } from "./items";
import { addProductionExtraReducers } from "./production";
import { addRemainsExtraReducers } from "./remains";
import { addSummaryExtraReducers } from "./summary";

export const registerCartExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  addProductionExtraReducers(builder);
  addRemainsExtraReducers(builder);
  addDealerRemainsExtraReducers(builder);
  addItemsExtraReducers(builder);
  addCheckoutExtraReducers(builder);
  addFiltersExtraReducers(builder);
  addSummaryExtraReducers(builder);
};
